/**
 * i18n — game UI strings. Arabic (Modern Standard, clean register) is the
 * default; the choice is shared with the landing page through one
 * localStorage key.
 */
const KEY = 'chickenroad.lang';

export const getLang = () => {
  const l = localStorage.getItem(KEY);
  return l === 'en' ? 'en' : 'ar';
};

export const setLang = (l) => localStorage.setItem(KEY, l === 'en' ? 'en' : 'ar');

const DICT = {
  ar: {
    dir: 'rtl',
    howto: 'كيف تلعب؟',
    bet: 'الرهان',
    difficulty: 'الصعوبة',
    diffNames: { easy: 'سهل', medium: 'متوسط', hard: 'صعب', hardcore: 'هاردكور' },
    odds: (k) => `احتمال الدهس: <b>${k} من 25</b>`,
    play: 'العب',
    go: 'اقفز',
    cashout: 'اسحب',
    modalTitle: 'كيف تلعب؟',
    modalSteps: [
      'حدّد رهانك واختر مستوى الصعوبة. كلما زادت الصعوبة كبرت المضاعفات وزاد عدد السيارات.',
      'اضغط <b>العب</b> ثم <b>اقفز</b> في كل خطوة. كل غطاء تصل إليه يرفع مضاعفك.',
      'اضغط <b>اسحب</b> في أي لحظة لتحصل على رهانك مضروباً بالمضاعف، أو غامر بخطوة إضافية.',
      'إذا مرّت سيارة قبل أن تسحب، خسرت الرهان. هذه هي قواعد الطريق.',
    ],
    gotIt: 'فهمت',
    fair: (c) => `جولات عادلة قابلة للتحقق. بصمة الجولة: ${c}…`,
    lost: (x) => `دُهست! خسرت $${x}`,
    topup: 'تم تجديد رصيدك التجريبي 🐔',
    toggleLabel: 'EN',
  },
  en: {
    dir: 'ltr',
    howto: 'How to play?',
    bet: 'Bet',
    difficulty: 'Difficulty',
    diffNames: { easy: 'Easy', medium: 'Medium', hard: 'Hard', hardcore: 'Hardcore' },
    odds: (k) => `Chance of being run over: <b>${k} out of 25</b>`,
    play: 'Play',
    go: 'GO',
    cashout: 'CASH OUT',
    modalTitle: 'How to play?',
    modalSteps: [
      'Set your bet and pick a difficulty. Harder roads pay more but hide more cars.',
      'Press <b>Play</b>, then <b>GO</b> for each step. Every manhole you reach raises your multiplier.',
      'Press <b>CASH OUT</b> any time to bank your bet times the multiplier, or push one more lane.',
      'If a car gets there before you cash out, the bet is gone. That is the road.',
    ],
    gotIt: 'Got it',
    fair: (c) => `Provably fair. Round commitment: ${c}…`,
    lost: (x) => `Run over! You lost $${x}`,
    topup: 'Balance refilled, on the house 🐔',
    toggleLabel: 'عربي',
  },
};

export const t = () => DICT[getLang()];
